/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
import { NbIconLibraries } from '@nebular/theme';
import { HttpClient } from '@angular/common/http';
import { MyMenuService } from './tool/service/menu.service';

@Component({
  selector: 'ngx-app',
  template: `
  <router-outlet></router-outlet>`,
  styleUrls: []
})
export class AppComponent implements OnInit {

  constructor(private analytics: AnalyticsService, 
    private seoService: SeoService,
    private http: HttpClient,
    private nbIconLibraries:NbIconLibraries,
    private ms :MyMenuService,) {
  }

  version = null
  IntervalRef = null

  ngOnInit(): void {
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();

    // let my = this
    // this.IntervalRef = setInterval(()=>{
    //   my.GetVersion()
    

    // },180000)

  }





}
